const IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif']

function getAttachmentUrl(item) {
  if (typeof item === 'string') return item
  if (item?.url) return item.url
  if (item?.path) return item.path

  return String(item || '')
}

export function normalizeAttachmentList(value) {
  if (!value) return []

  const rawItems = (Array.isArray(value) ? value : [value]).flatMap(item => {
    const rawValue = getAttachmentUrl(item)
    const label = item?.label

    return String(rawValue || '')
      .split(',')
      .map(part => ({
        url: part.trim(),
        label
      }))
  })

  return Array.from(
    rawItems
      .reduce((acc, item) => {
        if (!item.url) return acc
        if (acc.some(existing => existing.url === item.url)) return acc

        acc.push(item)
        return acc
      }, [])
  )
}

export function isImageUrl(attachment) {
  const url = getAttachmentUrl(attachment)
  if (!url) return false

  const normalizedUrl = String(url).trim().toLowerCase()
  const pathname = normalizedUrl.split(/[?#]/, 1)[0]
  return IMAGE_EXTENSIONS.some(extension => pathname.endsWith(`.${extension}`))
}

export function getAttachmentLabel(attachment, fallbackLabel) {
  if (attachment?.label) return attachment.label

  const url = getAttachmentUrl(attachment)
  if (!url) return fallbackLabel

  try {
    const parsed = new URL(url)
    const segments = parsed.pathname.split('/').filter(Boolean)
    const filename = segments[segments.length - 1]
    return filename ? decodeURIComponent(filename) : fallbackLabel
  } catch {
    const segments = String(url).split('/').filter(Boolean)
    return segments[segments.length - 1] || fallbackLabel
  }
}
